
function AboutCareersComponent() {
    return (
      <div className="ErrorComponent">
        <h1>AboutCompanyComponent</h1>
        <div>AboutCompanyComponent</div>
      </div>
    )
  }   
  
  
    export default AboutCareersComponent;  